import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ActionService } from '../../services/action.service';
import { HistoriqueResponse } from '../fiche-credit/models';

export const planificationResolver: ResolveFn<HistoriqueResponse> = () => {
  return inject(ActionService).getAllActions();
};
